import { useQuery } from 'react-query';
import * as api from '../../services/api';

export const HELP_DESK_EMPLOYEE_TICKETS_QUERY_KEY = 'helpDeskEmployeeTickets';

export const getHelpDeskEmployeeTicketsQueryKey = (accountId, employeeId) => [
  HELP_DESK_EMPLOYEE_TICKETS_QUERY_KEY,
  accountId,
  employeeId
];

const useHelpDeskEmployeeTickets = ({ accountId, employeeId, limit, offset, onSuccess }) => {
  const queryKey = [...getHelpDeskEmployeeTicketsQueryKey(accountId, employeeId), offset];

  const { isLoading } = useQuery(
    queryKey,
    () => api.fetchEmployeeHelpDeskTickets({ accountId, employeeId, limit, offset }),
    {
      enabled: !!accountId && !!employeeId,
      refetchOnWindowFocus: false,
      onSuccess
    }
  );

  return { isLoading };
};

export default useHelpDeskEmployeeTickets;
